import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-redressal', templateUrl: './redressal.component.html', styleUrls: ['./redressal.component.scss'] })
export class RedressalComponent implements OnInit { constructor() { } ngOnInit(): void { } }
